import { css } from '@emotion/react';

const HoldingsOverTimeChartStyles = css`
    li {
        list-style: none;
    }

    .sr-only {
        display: none;
    }

    table {
        width: 100%;
        margin-top: 10px;
    }

    tbody {
        display: flex;
        justify-content: end;
        flex-wrap: wrap;
        tr {
            width: 40%;
        }
    }
`;

export default HoldingsOverTimeChartStyles;
